import React from 'react';
import { Modal, Button, ButtonGroup, Stack, Heading, Text, Icon } from '@chaser/components';

const BasicModal = ({
  open,
  close,
  onClosed,
  title,
  description,
  subDescription,
  onSubmit,
  onSubmitText,
  loading,
}) => {
  return (
    <Modal size="small" open={open} toggle={close} onClosed={onClosed}>
      <Modal.Body>
        <Stack gap="medium" alignItems="center">
          <Icon name="warning-circle" size="20" />
          {title && (
            <Heading fontSize="large" textAlign="center">
              {title}
            </Heading>
          )}
          {description && <Text textAlign="center">{description}</Text>}
          {subDescription && <Text textAlign="center">{subDescription}</Text>}
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup flex={1} justifyContent="center">
          <Button loading={loading} onClick={onSubmit ?? close}>
            {onSubmitText ?? 'Close'}
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default BasicModal;
